"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnCreditCardTransaction = exports.voidCreditCardTransaction = exports.reverseCreditCardTransaction = exports.getTransactionQuery = exports.setupTransaction = void 0;
const shared_1 = require("@getgreenline/shared");
const convertTransactionSetupFromJsonToXml_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertTransactionSetupFromJsonToXml");
const convertFromXmlToJson_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertFromXmlToJson");
const findNestedObjectValue_1 = require("../../../models/worldpay/system/helpers/findNestedObjectValue");
const convertTransactionQueryFromJsonToXml_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertTransactionQueryFromJsonToXml");
const convertCreditCardReversalFromJsonToXml_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertCreditCardReversalFromJsonToXml");
const ConvertCreditCardVoidFromJsonToXml_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/ConvertCreditCardVoidFromJsonToXml");
const convertCreditCardReturnFromJsonToXml_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertCreditCardReturnFromJsonToXml");
const getHostResponseCodeMessage_1 = require("../../../models/worldpay/transaction/helpers/getHostResponseCodeMessage");
const getDefaultResponseFields = (json) => {
    const expressResponseCode = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'ExpressResponseCode');
    const expressResponseMessage = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'ExpressResponseMessage');
    const hostResponseCode = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'HostResponseCode');
    const hostResponseMessage = hostResponseCode
        ? (0, getHostResponseCodeMessage_1.getHostResponseCodeMessage)(hostResponseCode)
        : undefined;
    const transactionId = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'TransactionID');
    if (expressResponseCode === undefined)
        throw Error('ExpressResponseCode not found in response');
    return {
        expressResponseCode,
        expressResponseMessage,
        hostResponseCode,
        hostResponseMessage,
        transactionId,
    };
};
const setupTransaction = async (params) => {
    const xml = (0, convertTransactionSetupFromJsonToXml_1.convertTransactionSetupFromJsonToXml)(params);
    const res = await shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data);
    const transactionSetupId = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'TransactionSetupID');
    return {
        ...getDefaultResponseFields(json),
        transactionSetupId,
        response: json,
    };
};
exports.setupTransaction = setupTransaction;
const getTransactionQuery = async (params) => {
    const xml = (0, convertTransactionQueryFromJsonToXml_1.convertTransactionQueryFromJsonToXml)({
        credentials: params.credentials,
        application: params.application,
        transactionQuery: params.transactionQuery,
    });
    const res = await shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data, {
        isArray: (tagName) => tagName === 'Item',
    });
    return {
        ...getDefaultResponseFields(json),
        response: json,
    };
};
exports.getTransactionQuery = getTransactionQuery;
const reverseCreditCardTransaction = async (params) => {
    const xml = (0, convertCreditCardReversalFromJsonToXml_1.convertCreditCardReversalFromJsonToXml)({
        credentials: params.credentials,
        application: params.application,
        transaction: params.transaction,
    });
    const res = await shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data);
    return {
        ...getDefaultResponseFields(json),
        response: json,
    };
};
exports.reverseCreditCardTransaction = reverseCreditCardTransaction;
const voidCreditCardTransaction = async (params) => {
    const xml = (0, ConvertCreditCardVoidFromJsonToXml_1.convertCreditCardVoidFromJsonToXml)({
        credentials: params.credentials,
        application: params.application,
        transaction: params.transaction,
    });
    const res = await shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data);
    return {
        ...getDefaultResponseFields(json),
        response: json,
    };
};
exports.voidCreditCardTransaction = voidCreditCardTransaction;
const returnCreditCardTransaction = async (params) => {
    const xml = (0, convertCreditCardReturnFromJsonToXml_1.convertCreditCardReturnFromJsonToXml)({
        credentials: params.credentials,
        application: params.application,
        transaction: params.transaction,
    });
    const res = await shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data);
    return {
        ...getDefaultResponseFields(json),
        response: json,
    };
};
exports.returnCreditCardTransaction = returnCreditCardTransaction;
//# sourceMappingURL=WorldpayCNPServerTransactionAPI.js.map